import { RouteConfig } from '/@/modules/core/app/helpers/RouteConfig';

export class RouteListConfig {
  /**
   * @var {string}
   */
  feature;

  /**
   * @var {RouteConfig[]}
   */
  routeConfigs = [];

  /**
   * @returns {object<Vue.Route>[]}
   */
  build() {
    return this.routeConfigs.map((config) => config.route);
  }

  /**
   * @param {object<Vue.Route>[]} routes
   * @returns {RouteListConfig}
   */
  static factory(routes) {
    const config = new this();
    routes.forEach((route) => {
      config.routeConfigs.push(RouteConfig.factory(route));
    });

    return config;
  }
}
